import { red } from "@material-ui/core/colors";
import { createMuiTheme } from "@material-ui/core/styles";
// A custom theme for this app
const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#556cd6",
    },
    secondary: {
      main: "#19857b",
    },
    error: {
      main: red.A400,
    },
    background: {
      default: "#fff",
    },
  },
  overrides: {
    MuiDialog: {
      // Name of the rule
      paperFullScreen: {

      },
    },
    MuiList: {
      padding: {
        paddingTop: 0,
        paddingBottom: 0
      }
    },
    MUIDataTable: {
      paper: {
        //padding:24
        boxShadow: 'inset 0 -1px 0 0 #e1e1e1'
      },
      responsiveBase: {
        border: '1px solid #dfe2e5',
        borderRadius: 4,
        //maxHeight: 'calc(100vh - 370px) !important',
        //height: 'auto !important'
      }
    },
    MUIDataTableHead: {
    },
    MUIDataTableBodyRow: {
      root: {
        height: 56,
        maxHeight: 56,
        minHeight: 56,
        fontWeight: 300,
        cursor: 'pointer',
        '&:nth-of-type(even)': {
          backgroundColor: '#f1f1f3',
        },
      }
    },
    MUIDataTableSelectCell: {
      fixedHeader: {
        backgroundColor: "#f1f1f3"
      },
      headerCell: {
        backgroundColor: "#f1f1f3"
      }
    },
    MUIDataTableHeadCell: {
      root: {
        backgroundColor: "#f1f1f3",
        fontWeight: 'bold'
      },
      sortLabelRoot: {
        height: 'auto'
      },
      fixedHeader: {
        backgroundColor: "#e3e8fd",
        border: '1px solid #dfe2e5',
        paddingBottom:10,
        paddingTop:10,
        top:-1
      }
    },
    MUIDataTableBodyCell: {
      root: {
        fontWeight: 'bold',
        color: '#161f34'
      },
      stackedParent: {
        border: '1px solid #dfe2e5',
        borderTop: 'none',
        paddingTop:8,
        paddingBottom:8
      }
    },
    MUIDataTableSearch: {
      searchText: {
        '& .MuiInputBase-root': {
          height: 36,
          '& .MuiInputAdornment-root': {
            color: '#B8B8B8'
          }
        }
      },
      searchIcon: {
        display: 'none'
      },
      clearIcon: {
        display: 'none'
      }
    },
    MUIDataTableFilterList: {
      root: {
        marginBottom: 4
      }
    },
    MUIDataTableToolbar: {
      root: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 24,
        paddingBottom: 24
      },
      filterPaper: {
        minWidth: '30em'
      }

    },

  }
});
export default theme;
